import { http } from "./http_service"

export function userUpdate(data, user_id) {
    return http().put(`/user/update/${user_id}`, data)
}
